<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link tag="span" class="ton__zhi2" to="/downloadSection"
                >下载专区</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">资讯详情</span>
            </div>
          </div>
        </div>
        <div class="box-contenta">
          <div class="box-tit">{{ listtodo.title }}</div>
          <div class="box-tim">
            <div class="zhuanzai">转载于：{{ listtodo.from }}</div>
            <div class="fabu-tim">发布时间：{{ listtodo.createtime }}</div>
          </div>
          <div class="box-text" v-html="listtodo.content"></div>
          <div class="">
            <div class="fujian" v-for="(item, index) in file_list" :key="index">
              <div class="fu">附件：</div>
              <div class="fu-name">{{ item.file_name }}</div>
              <div class="xiazaigu">
                <img
                  src="../../assets/img/img_14.png"
                  alt
                  @click="xizaiolkeg(item.file)"
                />
              </div>
            </div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>
<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      id: "",
      listtodo: [],
      file: '',
      bei_ing: this.Public.bei_ing,
      file_list: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    console.log(this.id);
    this.getinde();
  },
  methods: {

    // xizaiolkeg() {
    //   if (this.file != '') {
    //     window.location.href = this.file;
    //   } else {
    //     this.$message.error('没有配置下载文件')

    //   }
    // },
    xizaiolkeg(file) {
      if (file != '') {
        console.log(file);
        window.location.href = file;
      } else {
        this.$message.error('没有配置下载文件')
      }
    },
    //通知公告详情接口
    getinde() {
      let that = this, url = "lists/download_info", param = {
        id: that.id,
      };
      that.post(url, param)
        .then((res) => {
          that.listtodo = res.data
          // that.file = res.data.file
          this.file_list = res.data.file_list
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "../../css/policyation.css";
</style>
